export default "__VITE_ASSET__BfaNUkWs__"